module.exports = __webpack_public_path__ + "static/stores-ordering-0ca6321fd9a5dc064837a6661f02d1d0.png";